import axios from '@/plugins/axios.js';

export function toRelativeLaunchUrl(url) {
    if (!url || typeof url !== 'string') {
        return url;
    }

    if (url.startsWith('/')) {
        return url;
    }

    try {
        const parsed = new URL(url, window.location.origin);

        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
        return url;
    }
}

export async function fetchPackagePreview(packageId, itemId = null) {
    const payload = itemId ? { elearning_package_item_id: itemId } : {};

    const { data } = await axios.post(`/api/elearning-packages/${packageId}/preview`, payload);

    if (data?.launch_url) {
        data.launch_url = toRelativeLaunchUrl(data.launch_url);
    }

    return data;
}

export async function fetchPackageLaunch(activityId, itemId = null) {
    const payload = itemId ? { elearning_package_item_id: itemId } : {};

    const { data } = await axios.post(`/api/activities/${activityId}/elearning-package/launch`, payload);

    if (data?.launch_url) {
        data.launch_url = toRelativeLaunchUrl(data.launch_url);
    }

    return data;
}
